import { ActionReducerMap, createReducer, MetaReducer, on } from '@ngrx/store';
import { setSmartRecoPathologies } from './actions/smart-reco-patient.actions';
import {
  getSmartRecoCatalogProducts,
  getSmartRecoCatalogProductsSuccess,
  getSmartRecoNotRecommendedProduct,
  getSmartRecoNotRecommendedProductSuccess,
  getSmartRecoNutritionalAssessment,
  getSmartRecoNutritionalAssessmentSuccess,
  getSmartRecoNutritionalAssessmentError,
  getSmartRecoRecommendation,
  getSmartRecoRecommendationSuccess,
  getSmartRecoRelatedWetProductsSuccess,
  removeSmartRecoNotRecommendedProduct,
  resetSmartRecoProductRecommendationError,
  setSmartRecoProductRecommendationErrorType,
  setSmartRecoProductRecommendationSessionIdError,
  incrementRetryRecommendationCount,
  setSmartRecoProductsCostPerDay,
  setSmartRecoNotRecommendedProductCostPerDay,
  setIsSelectedIndividualisProduct,
} from './actions/smart-reco-recommendation.actions';
import {
  resetSmartRecoState,
  setSmartRecoStep,
  setSmartRecoSteps,
  setSmartRecoLastStepBeforeAllowance,
} from './actions/smart-reco-steps.actions';
import { initialSmartRecoState, SmartRecoState } from './smart-reco.state';

export const reducers: ActionReducerMap<SmartRecoState> = {
  recommendation: createReducer(
    initialSmartRecoState.recommendation,
    on(resetSmartRecoState, getSmartRecoRecommendation, () => initialSmartRecoState.recommendation),
    on(getSmartRecoRecommendationSuccess, (_, { recommendation }) => recommendation),
  ),
  retryCount: createReducer(
    initialSmartRecoState.retryCount,
    on(incrementRetryRecommendationCount, (state) => state + 1),
    on(resetSmartRecoState, resetSmartRecoProductRecommendationError, () => initialSmartRecoState.retryCount),
  ),
  nutritionalAssessment: createReducer(
    initialSmartRecoState.nutritionalAssessment,
    on(resetSmartRecoState, getSmartRecoNutritionalAssessment, () => initialSmartRecoState.nutritionalAssessment),
    on(getSmartRecoNutritionalAssessmentSuccess, (_, { nutritionalAssessment }) => nutritionalAssessment),
  ),
  nutritionalAssessmentHasError: createReducer(
    initialSmartRecoState.nutritionalAssessmentHasError,
    on(getSmartRecoNutritionalAssessmentError, () => true),
    on(getSmartRecoNutritionalAssessmentSuccess, () => false),
    on(getSmartRecoNutritionalAssessment, () => false),
  ),
  nutritionalAssessmentLoading: createReducer(
    initialSmartRecoState.nutritionalAssessmentLoading,
    on(getSmartRecoNutritionalAssessment, () => true),
    on(getSmartRecoNutritionalAssessmentSuccess, () => false),
    on(getSmartRecoNutritionalAssessmentError, () => false),
  ),
  recommendationErrorType: createReducer(
    initialSmartRecoState.recommendationErrorType,
    on(resetSmartRecoState, resetSmartRecoProductRecommendationError, () => initialSmartRecoState.recommendationErrorType),
    on(setSmartRecoProductRecommendationErrorType, (_, { value }) => value),
  ),
  recommendationSessionIdError: createReducer(
    initialSmartRecoState.recommendationSessionIdError,
    on(resetSmartRecoState, resetSmartRecoProductRecommendationError, () => initialSmartRecoState.recommendationSessionIdError),
    on(setSmartRecoProductRecommendationSessionIdError, (_, { value }) => value),
  ),
  notRecommendedProduct: createReducer(
    initialSmartRecoState.notRecommendedProduct,
    on(
      resetSmartRecoState,
      getSmartRecoNotRecommendedProduct,
      getSmartRecoRecommendation,
      removeSmartRecoNotRecommendedProduct,
      () => initialSmartRecoState.notRecommendedProduct,
    ),
    on(getSmartRecoNotRecommendedProductSuccess, (_, { notRecommendedProduct }) => notRecommendedProduct),
  ),
  catalogProducts: createReducer(
    initialSmartRecoState.catalogProducts,
    on(resetSmartRecoState, getSmartRecoCatalogProducts, () => initialSmartRecoState.catalogProducts),
    on(getSmartRecoCatalogProductsSuccess, (_, { catalogProducts }) => catalogProducts),
  ),
  relatedWetProducts: createReducer(
    initialSmartRecoState.relatedWetProducts,
    on(resetSmartRecoState, getSmartRecoRecommendation, () => initialSmartRecoState.relatedWetProducts),
    on(getSmartRecoRelatedWetProductsSuccess, (_, { products }) => products),
  ),
  pathologies: createReducer(
    initialSmartRecoState.pathologies,
    on(resetSmartRecoState, () => initialSmartRecoState.pathologies),
    on(setSmartRecoPathologies, (_, { value }) => value),
  ),
  steps: createReducer(
    initialSmartRecoState.steps,
    on(resetSmartRecoState, () => initialSmartRecoState.steps),
    on(setSmartRecoSteps, (_, { value }) => value),
  ),
  step: createReducer(
    initialSmartRecoState.step,
    on(resetSmartRecoState, () => initialSmartRecoState.step),
    on(setSmartRecoStep, (_, { value }) => value),
  ),
  lastStepBeforeAllowance: createReducer(
    initialSmartRecoState.lastStepBeforeAllowance,
    on(setSmartRecoLastStepBeforeAllowance, (_, { value }) => value),
    on(resetSmartRecoState, () => initialSmartRecoState.lastStepBeforeAllowance),
  ),
  productsCostPerDay: createReducer(
    initialSmartRecoState.productsCostPerDay,
    on(setSmartRecoProductsCostPerDay, (_, { productsCostPerDay }) => productsCostPerDay),
    on(resetSmartRecoState, getSmartRecoRecommendation, () => initialSmartRecoState.productsCostPerDay),
  ),
  notRecommendedProductCostPerDay: createReducer(
    initialSmartRecoState.notRecommendedProductCostPerDay,
    on(
      removeSmartRecoNotRecommendedProduct,
      getSmartRecoRecommendation,
      resetSmartRecoState,
      () => initialSmartRecoState.notRecommendedProductCostPerDay,
    ),
    on(setSmartRecoNotRecommendedProductCostPerDay, (_, { costPerDay }) => costPerDay),
  ),
  isIndividualisSelected: createReducer(
    initialSmartRecoState.isIndividualisSelected,
    on(setIsSelectedIndividualisProduct, (_, { select }) => select),
    on(resetSmartRecoState, () => initialSmartRecoState.isIndividualisSelected),
  ),
};

export const metaReducers: MetaReducer<SmartRecoState>[] = [];
